var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SidebarLayoutContentWrapper from "./SidebarLayoutContentWrapper";
import BaseFrame from "../BaseFrame";
import { NotificationContainer, SidebarLayout } from "../../index";
import Tooltip from "../../Tooltip";
var DashboardFrame = function (_a) {
    var appName = _a.appName, title = _a.title, logo = _a.logo, primaryNavigation = _a.primaryNavigation, secondaryNavigation = _a.secondaryNavigation, secondaryNavigationTitle = _a.secondaryNavigationTitle, children = _a.children;
    primaryNavigation.map(function (i) { return i.current = i.name === title; });
    return (_jsxs(BaseFrame, __assign({ title: title, appName: appName }, { children: [_jsx(SidebarLayout, __assign({ appName: appName, primaryNavigation: primaryNavigation, secondaryNavigation: secondaryNavigation, secondaryNavigationTitle: secondaryNavigationTitle, logo: logo }, { children: _jsx(SidebarLayoutContentWrapper, { children: children }) })), _jsx(NotificationContainer, {}), _jsx(Tooltip, {})] })));
};
export default DashboardFrame;
